import { all, put, select, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import log from 'loglevel'

import config from '../../../../../../config'

import { RIBBON_ON_CHANGE_EVENT } from '../../../../components/Ribbon/components/HocOnChange/constants'
import { DROPDOWN_KEY, BUTTONSARRAY_KEY } from './constants'
import { TABS_TAB_ACTIVATED } from '../../../../components/Tabs/constants'

import { portfolioRibbonOnChange } from './actions'
import { toggleButtonsArrayButton } from '../../../../components/Ribbon/components/ButtonsArray/components/ConnectButton/actions'
import { activeItem } from '../../../../components/Ribbon/components/DropDown/actions'
import { changeBlockLevel as deleteLevel } from '../../../../components/Workspace/components/HocBlock/components/BlockTitle/components/LevelPicker/actions'
import {
    getActivePortfolioId,
    getActivePortfolioBlocksForDelete,
    portfolioTypeBlocksSelector,
    portfolioTypeToSelectSelector,
    blocksToToggleByActivePortfolio,
} from './selectors'

const MODULE_KEY = config.modules.portfolio.key

function* onChangePortfolioRibbonSaga(_action) {
    const { module, component, item } = _.get(_action, 'data', {})

    if (module === MODULE_KEY) {
        switch (component) {
            case DROPDOWN_KEY: {
                const blocksToToggle = yield select(portfolioTypeBlocksSelector, item)

                const togglesActions = blocksToToggle
                    .map((block) => put(toggleButtonsArrayButton(MODULE_KEY, BUTTONSARRAY_KEY, block)))
                    .toJS()
                yield all(togglesActions)

                const portfolioId = yield select(getActivePortfolioId)
                if (portfolioId) {
                    const blocksToDelete = yield select(getActivePortfolioBlocksForDelete, portfolioId)

                    const deleteActions = blocksToDelete
                        .map((block) => put(deleteLevel(MODULE_KEY, portfolioId, block, null)))
                        .toJS()
                    yield all(deleteActions)
                }

                break
            }
            case BUTTONSARRAY_KEY: {
                // Nothing to do (nothing in ribbon is affected by ButtonsArray change event)
                break
            }
            default:
                log.info(`Wrong ribbon component key: ${component}`)
        }

        // no async actions before => dispatch last
        yield put(portfolioRibbonOnChange())
    }
}

function* onTabActiveSaga(_action) {
    const tabType = _.get(_action, 'data.type', null)
    if (tabType !== MODULE_KEY) return null

    const portfolioId = _.get(_action, 'data.id', null)

    // setting for buttons array component
    const blocksToToggle = yield select(blocksToToggleByActivePortfolio, portfolioId)
    // create all toggles actions
    const togglesActions = blocksToToggle
        .map((block) => put(toggleButtonsArrayButton(MODULE_KEY, BUTTONSARRAY_KEY, block)))
        .toJS()
    // dispatch all toggles actions
    yield all(togglesActions)

    // setting for dropdown component
    const portfolioTypeToSelect = yield select(portfolioTypeToSelectSelector, portfolioId)
    if (portfolioTypeToSelect) yield put(activeItem(MODULE_KEY, DROPDOWN_KEY, portfolioTypeToSelect))

    return null
}

export default function* portfolioRibbonSaga() {
    yield all([
        takeEvery(RIBBON_ON_CHANGE_EVENT, onChangePortfolioRibbonSaga),
        takeEvery(TABS_TAB_ACTIVATED, onTabActiveSaga),
    ])
}
